import React from "react";

const Coins: React.FC = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9994 9.65217C20.9994 11.29 20.4075 12.7896 19.4259 13.9487C19.4312 13.8215 19.4339 13.6937 19.4339 13.5652C19.4339 8.59462 15.4045 4.56519 10.4339 4.56519C10.3056 4.56519 10.178 4.56787 10.051 4.57318C11.2101 3.59179 12.7095 3 14.3472 3C18.0211 3 20.9994 5.97828 20.9994 9.65217ZM17.8696 13.5652C17.8696 17.6713 14.5409 20.9999 10.4348 20.9999C6.32867 20.9999 3 17.6713 3 13.5652C3 9.45904 6.32867 6.13037 10.4348 6.13037C14.5409 6.13037 17.8696 9.45904 17.8696 13.5652ZM9.34545 8.70886H11.6551V12.0469H15V14.3526H12.581L14.7364 17.0005L12.945 18.455L10.5002 15.4514L8.05502 18.4543L6.26392 16.9995L8.41917 14.3526H6V12.0469H9.34545V8.70886Z"
        fill="white"
      />
    </svg>
  );
};

export default Coins;
